import { Pipe, PipeTransform } from '@angular/core';
import { AgentTypeEnum } from '@zaoblako/shared/modules/ai/enums/agent-type.enum';
import { AgentTypeEnumI18n } from '@zaoblako/shared/modules/ai/i18n/agent-type-enum.i18n';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';

@Pipe({
  name: 'agentTypeName',
  standalone: true
})
export class AgentTypeNamePipe implements PipeTransform {
  public transform(type: AgentTypeEnum): string {
    return AgentTypeEnumI18n[I18nLocalesEnum.RU_RU][type] || '';
  }
}
